module.exports = __webpack_public_path__ + "static/media/ic_involved_red.dc5f2abf.svg";